import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';

const { CUA_FILE_UPLOAD } = getObNextGenApiUrlLists();

interface FileToPromptRequest {
  fileContent: string;
  userPrompt: string;
  contentType: string;
  fileName: string;
  useCase: string;
}

interface FileToPromptResponse {
  success: boolean;
  prompt: string;
}

export const cuaFileUploadApi = createApi({
  reducerPath: 'cuaFileUploadApi',
  baseQuery: axiosBaseQuery({ baseUrl: getBaseUrlObNextGen() }),
  endpoints: (builder) => ({
    convertFileToPrompt: builder.mutation<
      FileToPromptResponse,
      FileToPromptRequest
    >({
      query: (payload) => ({
        url: CUA_FILE_UPLOAD,
        method: 'POST',
        data: payload,
        config: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      }),
    }),
  }),
});

export const { useConvertFileToPromptMutation } = cuaFileUploadApi;
